const posts = [
  {
    slug: "welcome",
    title: "Welcome to AutoPromote",
    date: "2026-01-02",
    content: `# Welcome to AutoPromote

We're excited to launch features focused on creator monetization and cross-platform promotion. This blog will feature product updates and best practices.
`,
  },
  {
    slug: "release-2026-01",
    title: "January 2026 Release",
    date: "2026-01-02",
    content: `# January 2026 Release

This release includes improved scheduling and platform integrations.
`,
  },
];

export default posts;
